import { render, staticRenderFns } from "./SpecialisationDel.vue?vue&type=template&id=0de3dddf&lang=pug&"
import script from "./SpecialisationDel.vue?vue&type=script&lang=js&"
export * from "./SpecialisationDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports